<template>
	<div class="app-data-card">
		<AppImage
			v-if="icon || fallback"
			class="app-data-card__icon"
			:src="icon"
			:fallback="fallback"
		/>

		<div class="app-data-card__details">
			<div class="app-data-card__value" v-if="value">{{ value }}</div>
			<div class="app-data-card__name" v-else>{{ $t('no_data') }}</div>
			<div class="app-data-card__name">{{ name }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'icon',
		'value',
		'name',
		'fallback'
	]
}
</script>

<style lang="scss" scoped>
.app-data-card {
	box-shadow: 0 2px 6px #00000026;
	border-radius: 5px;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	background-color: #fff;

	&__icon {
		flex-shrink: 0;
		width: 30px;
		height: 30px;
		margin-right: 20px;
	}

	&__details {
		flex: 1 1 auto;
	}

	&__value {
		font-size: 1em;
		color: $default;
		font-weight: 600;
		margin-bottom: .10px;
	}

	&__name {
		font-size: .8em;
		color: $default-light;
	}
}
</style>
